import { LeasingOffer } from 'common/interfaces';

export const getUniqueValues = (leasingOffers: LeasingOffer[], prop: keyof LeasingOffer) => {
  return Array.from(new Set(leasingOffers.map(leasingOffer => leasingOffer[prop]))).sort(
    (a, b) => (a as number) - (b as number)
  );
};
